<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/devices">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="device_name detail_content">
            <div class="device_name_label detail_label">
              {{ deviceNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('deviceName')"
            />
          </div>
          <div class="phone_number detail_content">
            <div class="phone_number_label detail_label">
              {{ phoneNumberLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('phoneNumber')"
            />
          </div>
          <div class="personal_device_flag detail_content">
            <div class="personal_device_flag_label detail_label">
              {{ personalDeviceFlagLabel }}
            </div>
            <div class="device_radio_buttons">
              <label>
                <input
                  type="radio"
                  class="device_radio_button"
                  name="personal_device_flag"
                  value="true"
                  checked
                />
                {{ personalDeviceTrueLabel }}
              </label>
              <label>
                <input
                  type="radio"
                  class="device_radio_button"
                  name="personal_device_flag"
                  value="false"
                />
                {{ personalDeviceFalseLabel }}
              </label>
            </div>
          </div>
          <div class="call_app detail_content">
            <div class="call_app_label detail_label">
              {{ callAppLabel }}
            </div>
            <select
              class="drop_down_list"
              @change="inputAddUpdate('callAppDivision')"
            >
              <option disabled selected value="">{{
                callAppList[0].callAppName
              }}</option>
              <option
                v-for="callApp in callAppList"
                :value="callApp.id"
                :key="callApp.id"
              >
                {{ callApp.callAppName }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addDevice"> </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      deviceIdLabel: '端末ID',
      deviceNameLabel: '端末名',
      phoneNumberLabel: '電話番号',
      personalDeviceFlagLabel: '使用用途',
      personalDeviceTrueLabel: '個人端末',
      personalDeviceFalseLabel: '共用端末',
      callAppLabel: '連携アプリ',
      personalDeviceFlag: true,
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    callAppList() {
      return this.$store.state.masters.masterData.callAppList
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  created() {
    this.$store.dispatch('devices/clearDevice')
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('devices/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/devices')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async addDevice(e) {
      this.showloadingModal = true
      var personalDeviceFlags = document.getElementsByName(
        'personal_device_flag'
      )
      var personalDeviceFlag
      for (let i = 0; i < personalDeviceFlags.length; i++) {
        if (personalDeviceFlags[i].checked) {
          /** 文字列になるためboolで格納 */
          if (personalDeviceFlags[i].value === 'true') {
            personalDeviceFlag = true
          } else {
            personalDeviceFlag = false
          }
          break
        }
      }
      await this.$store.dispatch(
        'devices/changePersonalDeviceFlag',
        personalDeviceFlag
      )
      try {
        await this.$store.dispatch('devices/addDevice')
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_340001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0014') {
            this.failureWord =
              this.errorMsg.MSGCRC0014.name +
              this.errorMsg.MSGCRC0014.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0015') {
            this.failureWord =
              this.errorMsg.MSGCRC0015.name +
              this.errorMsg.MSGCRC0015.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0092') {
            this.failureWord =
              this.errorMsg.MSGCRC0092.name +
              this.errorMsg.MSGCRC0092.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0097') {
            this.failureWord =
              this.errorMsg.MSGCRC0097.name +
              this.errorMsg.MSGCRC0097.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0098') {
            this.failureWord =
              this.errorMsg.MSGCRC0098.name +
              this.errorMsg.MSGCRC0098.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0124') {
            this.failureWord =
              this.errorMsg.MSGCRC0124.name +
              this.errorMsg.MSGCRC0124.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0146') {
            this.failureWord =
              this.errorMsg.MSGCRC0146.name +
              this.errorMsg.MSGCRC0146.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0168') {
            this.failureWord =
              this.errorMsg.MSGCRC0168.name +
              this.errorMsg.MSGCRC0168.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0016.name +
              this.errorMsg.MSGCRC0016.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0016'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0016.name +
            this.errorMsg.MSGCRC0016.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/deviceAdd.vue